import useReservationStore from '@/composables/store/useReservationStore';
import { useStore } from '@/store';
import { watch } from 'vue';

const methodsCalled: Map<string, number> = new Map();

export default function useCache(fetchMethod: string) {
  const { reservation } = useReservationStore();
  const store = useStore();
  watch(
    () => reservation.value?.location,
    async (location) => {
      if (!location?.id) {
        return;
      }
      if (methodsCalled.get(fetchMethod) !== location.id) {
        methodsCalled.set(fetchMethod, location.id);
        await store.dispatch(fetchMethod, location.id);
      }
    },
    { immediate: true, deep: true },
  );
}
